<template>
    <b-row class="my-3">
        <b-col cols="12">
            <classification :classification="classification"/>
        </b-col>
    </b-row>
</template>

<script>

import {mapActions, mapState} from 'vuex';
import Classification from '../../../components/classification.vue';

export default {
    name: 'index',
    components: {Classification},
    computed: {
        ...mapState('calculator', [
            'product',
            'categories',
            'classification'
        ])
    },
    async mounted() {
        await this.getClassification({product_id: this.product.id, danger_code: 'MCAL07'});
    },
    methods: {
        ...mapActions('calculator', [
            'getClassification'
        ])
    }
};
</script>
